import {
  ICreateUserRequest,
  ICreateUserResponse,
  IDeleteByIdRequest,
  IDeleteUserResponse,
  IGetAllUsersResponse,
  IGetByIdRequest,
  IGetUserByIdResponse,
  IPaginationRequest,
  IUpdateUserRequest,
  IUpdateUserResponse,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.masterData;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_USER = getUrl("get-all-users");
const URL_GET_USER_BY_ID = getUrl("get-user-by-id");
const URL_CREATE_USER = getUrl("create-user");
const URL_UPDATE_USER = getUrl("update-user");
const URL_DELETE_USER = getUrl("delete-user");

class UserApiService extends BaseApiService {
  public getAllUsers = (request: IPaginationRequest) =>
    this.get<IGetAllUsersResponse>(URL_GET_ALL_USER, {
      params: request,
    });
  public getUserById = (request: IGetByIdRequest) =>
    this.get<IGetUserByIdResponse>(URL_GET_USER_BY_ID, {
      params: request,
    });
  public createUser = (request: ICreateUserRequest) =>
    this.post<ICreateUserRequest, ICreateUserResponse>(
      URL_CREATE_USER,
      request
    );
  public updateUser = (request: IUpdateUserRequest) =>
    this.put<IUpdateUserRequest, IUpdateUserResponse>(URL_UPDATE_USER, request);
  public deleteUser = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteUserResponse>(URL_DELETE_USER, {
      params: request,
    });
}

export default new UserApiService();
